export default __webpack_public_path__ + "static/media/Wednesday_02.ed417950.png";